import {
  Antrag,
  ClosingScreenBase,
  EinreichungComponentType,
  EinreichungService,
  EinreichungStepResultType,
} from '@ebeihilfe/einreichung-old';
import { Component } from '@angular/core';
import { Deferred, EinreichungComponents, MessageBase } from '@ebeihilfe/core';
import { TranslateService } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-closing-screen',
  templateUrl: './closing-screen.component.html',
  styleUrls: ['./closing-screen.component.scss'],
  standalone: false,
})
export class ClosingScreenComponent
  extends ClosingScreenBase
  implements EinreichungComponentType<ClosingScreenComponent>
{
  public component = ClosingScreenComponent;
  public name = EinreichungComponents.ClosingScreen;

  constructor(translate: TranslateService, message: MessageBase, einreichungService: EinreichungService) {
    super(translate, message, einreichungService);
  }

  public async handle(
    antrag: Antrag,
    instance: ClosingScreenComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }
}
